import { AfterContentInit, Component, ContentChildren, OnDestroy, OnInit, QueryList } from '@angular/core';
import { AccordionComponent } from '../accordion.component';

@Component({
	selector: 'app-accordion-group',
	styleUrls: ['./accordion-group.component.css'],
	templateUrl: './accordion-group.component.html'
})
export class AccordionGroupComponent implements OnInit, AfterContentInit, OnDestroy {
	@ContentChildren(AccordionComponent) accordions: QueryList<AccordionComponent>;

	private subscriptions = [];
	private _accordions: QueryList<AccordionComponent>;

	constructor() {}

	ngOnInit(): void {}

	ngAfterContentInit(): void {
		this._accordions = this.accordions;
		this.removeSubscriptions();
		this.addSubscriptions();

		this.accordions.changes.subscribe((rex) => {
			this._accordions = rex;
			this.removeSubscriptions();
			this.addSubscriptions();
		});
		this.makeFirstAccordionActive();
	}

	addSubscriptions(): void {
		this._accordions.forEach((a) => {
			const subscription = a.toggleAccordion.subscribe((e) => {
				this.toogleAccordion(a);
			});
			this.subscriptions.push(subscription);
		});
	}

	removeSubscriptions(): void {
		this.subscriptions.forEach((sub) => {
			sub.unsubscribe();
		});
	}

	toogleAccordion(accordion: any): void {
		if (!accordion.active) {
			this.accordions.forEach((a) => (a.active = false));
		}
		// set active accordion
		accordion.active = !accordion.active;
	}

	makeFirstAccordionActive(): void {
		if (this.accordions[0]) {
			this.toogleAccordion(this.accordions[0]);
		}
	}

	ngOnDestroy(): void {
		this.removeSubscriptions();
	}
}
